import {
    Box,
    Button,
    Grid,
    Typography,
    InputAdornment,
    TextField,
    useTheme,
    TablePagination,
    Theme,
    IconButton,
    Tooltip
} from '@mui/material';

import { Link as RouterLink } from 'react-router-dom';
import { CommonLayout } from '../commonComponents';
import { useHistory } from 'react-router';
import { ChangeEvent, useEffect, useState } from 'react';
import { getAllApplications } from '../../redux-store/actions/application';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import React from 'react';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
import { useDebounce } from '../../utils/useDebounce';
import { InfoIconOutlined, SearchIcon } from '../../assets/SvgIcons';
import { APPLICATION_RE_KYC_STATUS, BseClientActivationStatusMaster } from '../../utils/constant';
import { whiteSpaceOnlyRegex } from '../../utils/regex';
import { ColumnType, DataTable } from '../DataTable';
import { checkIfApplicationIsNonIndividual, compare, getBseClientActivationStatus, getFirstHolderName, getFirstHolderPan, getIndividualType, isModuleAllowed, isOnboardingTypeMinor, maskInfo,getModeOfHoldingDisplay, } from '../../utils/utilityFunctions';
import BreadCrum from '../../lib/BreadCrum';
import { InitiateKYCDialog } from './InitiatekycDialog';

const getTableHeader = (): ColumnType[] => {
    const { permissions } = useSelector((state: RootStateType) => state.auth);
    return [
        {
            header: 'Application Number',
            label: 'applicationNumber',
            valueGetter: (row: ApplicationProps) => row.applicationNumber || 'N/A',
        },
        {
            header: 'Investor Name',
            valueGetter: ({ applicants = [], onboardingType }: ApplicationProps) =>
                maskInfo(isOnboardingTypeMinor(onboardingType as string) ? applicants[0]?.minorName || 'N/A' : getFirstHolderName(applicants)) || 'N/A',
        },
        {
            header: 'Investor PAN',
            valueGetter: ({ applicants = [] }: ApplicationProps) => maskInfo(getFirstHolderPan(applicants) ?? '') || 'N/A',
        },
        {
            header: 'Investor Type',
            valueGetter: ({ applicants = [], onboardingType }: ApplicationProps) => getIndividualType(applicants[0]?.status ?? '', onboardingType ?? '') || 'N/A',
        },
        {
            header: 'Mode of Holding',
            renderCell: (row: ApplicationProps) => {
                return (
                    <Typography
                        sx={{
                            textTransform: 'capitalize',
                        }}>
                        {getModeOfHoldingDisplay(row.modeOfHolding)??"-"}
                    </Typography>
                );
            },
        },
        {
            header: 'KRA Status',
            renderCell: (row: ApplicationProps) => {
                const { palette } = useTheme()
                return (
                    <Box
                        className={row?.allKRAVerified ? 'Success' : 'Pending'}
                        sx={{
                            '& .MuiTypography-root': {
                                color: palette.primary[500],
                            },
                            '&.Success .MuiTypography-root': {
                                color: palette.success[500],
                            },
                        }}>
                        <Typography
                            // component={RouterLink}
                            // to={
                            //     checkIfApplicationIsNonIndividual(row)
                            //         ? `/non-individual-application-details/${row.id}`
                            //         : `/application-details/${row.id}`
                            // }
                            sx={{ textDecoration: 'none', fontWeight: 700 }}>
                            {row.allKRAVerified ? 'Success' : 'Pending'}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            header: 'BSE Status',
            renderCell: (row: ApplicationProps) => {
                const { palette } = useTheme()
                return (
                    <Box
                        className={row.bseClientActivationStatus ?? ''}
                        sx={{
                            '& .MuiTypography-root': {
                                fontWeight: 500,
                                // fontSize: 16,
                                color: '#B78813',
                            },
                            '&.pending .MuiTypography-root': {
                                color: palette.primary[500],
                            },
                            '&.active .MuiTypography-root': {
                                color: palette.success[500],
                            },
                        }}>
                        <Typography
                            component={RouterLink}
                            to={
                                checkIfApplicationIsNonIndividual(row)
                                    ? `/non-individual-application-details/${row.id}`
                                    : `/application-details/${row.id}`
                            }
                            sx={{ textDecoration: 'none' }}>
                            {BseClientActivationStatusMaster[row.bseClientActivationStatus ?? ''] ?? 'Not Initiated'}
                        </Typography>
                        {isModuleAllowed({ value: "BSEStatus", compareArr: permissions, objKey: "permissonCode" }) && <Tooltip
                            slotProps={{
                                tooltip: {
                                    sx: {
                                        margin: "0px !important",
                                        backgroundColor: "transparent"
                                    }
                                }
                            }}
                            title={
                                <Box sx={{
                                    borderRadius: '10px',
                                    backgroundColor: '#0F131F',
                                    padding: '10px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    rowGap: '10px'  // Gap between each section
                                }}>
                                    {row?.isBSEEnabled ?
                                        <>
                                            <Box>
                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                    STATUS
                                                </Typography>
                                                <Typography variant='subtitle_600'>
                                                    {row?.bseStarServiceResponse ?? '-'}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                    CLIENT CREATION RESPONSE
                                                </Typography>
                                                <Typography variant='subtitle_600'>
                                                    {row?.bseStarResponse ?? '-'}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                    FATCA RESPONSE
                                                </Typography>
                                                <Typography variant='subtitle_600'>
                                                    {row?.bseFatcaResponse ?? '-'}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                    CHEQUE UPLOAD RESPONSE
                                                </Typography>
                                                <Typography variant='subtitle_600'>
                                                    {row?.cancelChequeUploadResponse ?? '-'}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                    AOF IMAGE RESPONSE
                                                </Typography>
                                                <Typography variant='subtitle_600'>
                                                    {row?.bseAofImageResponse ?? '-'}
                                                </Typography>
                                            </Box>
                                        </>
                                        :
                                        <Box sx={{ textAlign: 'center', borderBottom: '1px solid #333333' }}>
                                            <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                                Mutual Fund Transaction Disabled
                                            </Typography>
                                        </Box>
                                    }
                                    <Box>
                                        <Typography variant='subtitle_500' sx={(theme: Theme) => ({ fontWeight: '600', marginBottom: '5px', color: theme.palette.primary[500] })}>
                                            MPOWER STATUS
                                        </Typography>
                                        <Typography variant='subtitle_600'>
                                            {row?.mpowerResponse || '-'}
                                        </Typography>
                                    </Box>
                                </Box>
                            }
                        >
                            <IconButton>
                                <InfoIconOutlined />
                            </IconButton>
                        </Tooltip>}
                    </Box>
                );
            },
        },

    ];
}

const routerPath = [
    {
        name: 'Dashboard',
        path: '/dashboard',
        warning: true
    },
    {
        name: 'Non MF Product Applications',
        path: `/non-mf-applications`,
    },
]

export default function NonMFApplications(): JSX.Element {
    const history = useHistory();
    const { palette } = useTheme()
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(false);
    const [applicationsList, setApplicationsList] = useState<ApplicationProps[]>([]);
    const [noOfPages, setNoPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0)
    const [limit, setLimit] = useState(10);
    const {
        page,
        search: storeSearch,
    } = useSelector((store: RootStateType) => store.paramsObj);
    const [currentPage, setPage] = useState(page);
    const { role = '' } = useSelector((store: RootStateType) => store.auth);
    const [search, setSearch] = useState(storeSearch);
    const debounceSearchString = useDebounce(search, 500);
    const [applicationsListData, setApplicationsListData] = useState<ApplicationProps[]>([]);

    const [isDialogOpen, setDialogOpen] = useState<boolean>(false);
    const [row, setRow] = useState<ApplicationProps>({} as ApplicationProps);

    const theme = useTheme();

    useEffect(() => {
        setApplicationsListData(applicationsList);
    }, [applicationsList]);

    const getApplication = async () => {
        setLoading(true);
        setApplicationsList([]);
        try {
            const response = (await dispatch(
                getAllApplications({
                    page: currentPage,
                    search,
                    applicationType: '',
                    distributorId: '',
                    // status: status
                    //     .toString()
                    //     .replace('draft_send_back', 'draft')
                    //     .replace('draft,draft', 'draft'),
                    status: 'completed',
                    modeOfHolding: '',
                    applicationSentBack:
                        status.includes('draft_send_back') && !status.includes('draft') ? true : null,
                    diy: '',
                    accountType: '',
                    bseClientActivationStatus: 'disabled',
                    onboardingType: '',
                    rekycStatus: 'null,pending,completed,pending_from_mpower' // only for rekyc
                })
            )) as unknown as GetAllApplicantionsResponseBody;
            const { applications, pages, total, limit } = response || {};
            setApplicationsList(applications);
            setNoPages(pages);
            setTotalCount(total)
            setLimit(limit);
            setLoading(false);
        } catch (e) {
            console.error((e as Error).message);
            setLoading(false);
        }
    }

    useEffect(() => {
        getApplication()
    }, [currentPage, debounceSearchString]);

    const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const handleSearchText = (event: ChangeEvent<HTMLInputElement>) => {
        const searchedText = event.target.value.replace(/^\s+/g, '').replace(/\s+/g, ' ');
        event.target.value = searchedText;
        setPage(1);
        if (whiteSpaceOnlyRegex.test(searchedText)) return;
        setSearch(event.target.value);
    }

    const handleDialogClose = () => {
        setDialogOpen(false);
    }

    const additionalCell = {
        header: 'Action',
        renderEditDeleteCell: (row: ApplicationProps): JSX.Element => {

            const handleDialogOpen = () => {
                setDialogOpen(true);
                setRow(row);
            }

            return (
                <>
                    {
                        row.isBSEEnabled ?
                            <Typography>N/A</Typography> :
                            <Button
                                variant="outlined"
                                sx={(theme: Theme) => ({
                                    color: 'textDark.primary',
                                    backgroundColor: 'primary.500',
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    padding: '4px 16px',
                                    minWidth: 'auto',
                                    border: 'none',
                                    whiteSpace: 'nowrap',
                                    ...theme.typography.body_500,
                                    '&:hover': {
                                        backgroundColor: 'primary.200',
                                        border: 'none',
                                    },
                                    '&:disabled': {
                                        color: 'text.secondary',
                                        backgroundColor: 'background.default',
                                        // border: 'none',
                                        cursor: 'not-allowed',
                                    },
                                })}
                                onClick={handleDialogOpen}
                                disabled={row.applicants.length == 0 || row.isBSEEnabled}
                            >
                                Initiate
                            </Button >
                    }
                </>
            );
        },
    };

    return (
        <CommonLayout>
            <>

                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: '10px' }}>
                        <BreadCrum array={routerPath} />
                    </Box>
                    <Box sx={{ marginBottom: '20px', ml: '6px' }}>
                        <Typography sx={{ color: 'text.primary' }} variant='h1'>Non MF Product Applications</Typography>
                    </Box>

                    <Box
                        sx={{
                            borderRadius: '25px',
                            overflow: 'hidden',
                            backgroundColor: palette.background.paper,
                            width: '100%',
                        }}
                    >
                        <Grid
                            container
                            sx={{
                                p: '35px 30px',
                                pb: 0,
                                justifyContent: 'space-between',
                                alignItems: 'flex-end',
                                bgcolor: 'common.white',
                            }}>
                            <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
                                <Grid item>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        value={search}
                                        placeholder="Search Application"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSearchText(e)}
                                        fullWidth
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                            style: {
                                                borderRadius: '5px',
                                                border: `1px solid ${palette.text.secondary}B2`,
                                                height: '40px',
                                                width: '100%',
                                                maxWidth: '255px',
                                                ...theme.typography.body_400,
                                                background: 'transparent'
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#B2B2B2',
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: '#B2B2B2',
                                                },
                                            },
                                            '& input': {
                                                backgroundColor: 'transparent',
                                            },
                                            '& .MuiAutocomplete-option': {
                                                backgroundColor: 'transparent',
                                                '&[aria-selected]': {
                                                    backgroundColor: 'transparent',
                                                    color: '#000',
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                        <Box sx={{
                            width: '100%',
                            overflowX: 'auto'
                        }}>
                            <DataTable
                                isLoading={isLoading}
                                tableHeader={[...getTableHeader(), additionalCell]}
                                tableData={applicationsListData}
                                rowCustomStyles={{
                                    '&:last-child td, &:last-child th': { border: 0 },
                                    '.MuiTableCell-body ': { color: palette.text.primary, fontWeight: 500 },
                                    background: 'transparent',
                                }}
                                boxStyles={{ minWidth: 100 }}
                            />

                        </Box>
                        {!!applicationsList?.length && (
                            <TablePagination
                                style={{
                                    color: palette.text.primary[500],
                                    fontSize: 16,
                                    fontWeight: 500,
                                    padding: '20px 35px 35px 35px',
                                    // paddingLeft: '50px',
                                    // paddingBottom: '48px'
                                }}
                                rowsPerPageOptions={[]}
                                labelRowsPerPage=""
                                component="div"
                                count={totalCount}
                                rowsPerPage={limit}
                                page={currentPage - 1}
                                onPageChange={(event, num) => setPage(num + 1)}
                                // onRowsPerPageChange={(rowsPerPage) => console.log('rowsPerPage', rowsPerPage.target.value)}
                                sx={{
                                    color: palette.text.primary[500]
                                }} />
                            // <Stack direction="row" justifyContent="center" sx={{ mt: 5 }}>
                            //   <Pagination
                            //     count={noOfPages}
                            //     page={currentPage}
                            //     color="primary"
                            //     onChange={handlePageChange}
                            //   />
                            // </Stack>
                        )}
                    </Box>
                    {/* {!!applicationsList.length && (
            <Stack direction="row" justifyContent="center" sx={{ mt: 5 }}>
              <Pagination
                count={noOfPages}
                page={currentPage}
                color="primary"
                onChange={handlePageChange}
              />
            </Stack>
          )} */}
                </Box>
                <InitiateKYCDialog isDialogOpen={isDialogOpen} handleDialogClose={handleDialogClose} row={row} getApplication={getApplication} />
            </>
        </CommonLayout>
    );
}